export default {"src":"/_next/static/media/redact-services-chart.7d7380ae.svg","height":449,"width":601,"blurWidth":0,"blurHeight":0};